<template>
  <div>
    <div class="filters marginbot-20">
      <div class="empl-fbp-card">
        <div class="profile">
          <img :src="employeeData.profilePic" alt class="emp-image" />
          <div class="details">
            <p>{{employeeData.name}}</p>
            <p class="typeface">
              FBP Month :
              <span class="month">{{employeeData.fbpMonth}}</span>
            </p>
            <p class="twoColumnGrid">
              <span>Total Eligibility:</span>
              <span>{{employeeData.totalEligibility}}</span>
            </p>
            <p class="twoColumnGrid">
              <span>Total Claimed :</span>
              <span>{{employeeData.totalClaimed}}</span>
            </p>
            <p class="twoColumnGrid total-amount">
              <span>Total Approved :</span>
              <span>{{employeeData.totalApproved}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="empl-fbp-table marginbot-30"
      v-for="(particularItem, tableIndex) in particularsList"
      :key="tableIndex"
    >
      <table class="particular-table marginbot-20">
        <thead>
          <tr>
            <th v-for="(columnItem, columnIndex) in headerColumnList" v-bind:key="columnIndex+'a'">
              <tl-checkbox
                v-if="columnItem.key == 'approved' || columnItem.key == 'reject' || columnItem.key == 'onHold'"
                :label="columnItem.label"
                :name="columnItem.key"
                :id="columnItem.key"
                @change="showInputField($event,particularItem, columnItem.key)"
              />
              <span v-else>{{columnItem.label}}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in particularItem.claims" v-bind:key="index">
            <td v-for="(columnItem, columnIndex) in headerColumnList" v-bind:key="columnIndex">
              <!-- <txt
                v-if="particularItem.isApproved && columnItem.key == 'approved'"
                label
                :name="columnItem.key+tableIndex"
                :value="item[columnItem.key]"
                v-model="item[columnItem.key]"
                class="tableInput"
              />
              <txt
                v-if="particularItem.isRejected && columnItem.key == 'reject'"
                label
                :name="columnItem.key+tableIndex"
                :value="item[columnItem.key]"
                v-model="item[columnItem.key]"
                class="tableInput"
              />
              <txt
                v-if="particularItem.isOnHold && columnItem.key == 'onHold'"
                label
                :name="columnItem.key+tableIndex"
                :value="item[columnItem.key]"
                v-model="item[columnItem.key]"
                class="tableInput"
              /> -->
              <txt
                v-if="(columnItem.key == 'remark')"
                label
                :name="columnItem.key+index+tableIndex"
                :value="item[columnItem.key]"
                v-model="item[columnItem.key]"
                data-vv-as="remark"
                v-validate="'required'"
                :classname="errors.has(columnItem.key+index+tableIndex)"
                :errormsg="errors.first(columnItem.key+index+tableIndex)"
              />

              <tl-select v-if="(columnItem.key == 'actions')" labelText="name" :name="'action'+index+tableIndex" :options="actionsList"
              @change="(val) => item[columnItem.key] = val.id"></tl-select>

              <span
                v-if="!(columnItem.key == 'actions' || columnItem.key == 'remark')"
              >{{item[columnItem.key]}}</span>
            </td>
          </tr>
          <tr class="border-top">
            <td v-for="(columnItem, columnIndex) in headerColumnList" v-bind:key="columnIndex">
              <span v-if="columnItem.key == 'displayName'">Total</span>
              <span v-if="columnItem.key == 'claimAmount'">
                <b>{{particularItem.totalClaimed}}</b>
              </span>
              <span v-if="columnItem.key == 'eligibilityAmount'">
                <b>{{particularItem.totalEligibility}}</b>
              </span>
              <!-- <span v-if="particularItem.isApproved && (columnItem.key == 'approved')">
                <b>{{particularItem.totalApprovedAmount}}</b>
              </span>
              <span v-if="particularItem.isRejected && (columnItem.key == 'reject')">
                <b>{{particularItem.totalRejectedAmount}}</b>
              </span>
              <span v-if="particularItem.isOnHold && (columnItem.key == 'onHold')">
                <b>{{particularItem.totalOnHoldAmount}}</b>
              </span> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" class @click="$emit('cancel', false)"></btn>
          <btn text="Save" type="primary" class v-on:click="save"></btn>
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import loginShellVue from '../../../../../../auth/views/loginShell.vue';
export default {
  name: "EmployeeFBPPage",
  props: {
    employeeDetails: Object
  },
  data() {
    return {
      employeeData: {
        profilePic: "",
        name: "",
        fbpMonth: "",
        totalEligibility: "",
        totalClaimed: "",
        totalApproved: ""
      },
      isChecked: [],
      actionsList: [{
        name:"Approved",
        id:"APPROVED"
      },
      {
        name:"Partially Approved",
        id:"PARTIALLYAPPROVED"
      },
      {
        name:"Rejected",
        id:"REJECTED"
      },
      {
        name:"On Hold",
        id:"ONHOLD"
      }],
      particularsList: [
        // {
        //   isApproved: false,
        //   isRejected: false,
        //   isOnHold: false,
        //   totalClaimedAmount: "900",
        //   totalEligibilityAmount: "2000",
        //   totalApprovedAmount: "200",
        //   totalRejectedAmount: "300",
        //   totalOnHoldAmount: "100",
        //   dataList: [
        //       {
        //       particulars: "Medical",
        //       billDate: "07 July 2019",
        //       claimAmount: "₹2000.00",
        //       bills: "attachment1.pdf",
        //       eligiblityAmount: "₹2000.00",
        //       approved: "2500",
        //       reject: "",
        //       onHold: "",
        //       remark: ""
        //     },
        //     {
        //       particulars: "",
        //       billDate: "07 July 2019",
        //       claimAmount: "₹2000.00",
        //       bills: "attachment2.pdf",
        //       eligiblityAmount: "₹2000.00",
        //       approved: "2000",
        //       reject: "",
        //       onHold: "",
        //       remark: ""
        //     }
        //   ]
        // },
        // {
        //   isApproved: false,
        //   isRejected: false,
        //   isOnHold: false,
        //   totalClaimedAmount: "1200",
        //   totalEligibilityAmount: "3000",
        //   totalApprovedAmount: "300",
        //   totalRejectedAmount: "200",
        //   totalOnHoldAmount: "800",
        //   dataList: [
        //     {
        //       particulars: "Fuel",
        //       billDate: "07 July 2019",
        //       claimAmount: "₹2000.00",
        //       bills: "attachment1.pdf",
        //       eligiblityAmount: "₹2000.00",
        //       approved: "2300",
        //       reject: "",
        //       onHold: "",
        //       remark: ""
        //     },
        //     {
        //       particulars: "",
        //       billDate: "07 July 2019",
        //       claimAmount: "₹2000.00",
        //       bills: "attachment2.pdf",
        //       eligiblityAmount: "₹2000.00",
        //       approved: "1900",
        //       reject: "",
        //       onHold: "",
        //       remark: ""
        //     }
        //   ]
        // }
      ],

      headerColumnList: [
        { label: "Particulars", key: "displayName" },
        { label: "Bill Date", key: "billDate" },
        { label: "Claim Amount", key: "claimAmount" },
        { label: "Bills", key: "bills" },
        { label: "EligiblityAmount", key: "eligibilityAmount" },
        { label: "Actions", key: "actions" },
        // { label: "Approved", key: "approved", enable: false },
        // { label: "Reject", key: "reject", enable: false },
        // { label: "On Hold", key: "onHold", enable: false },
        { label: "Remark", key: "remark" }
      ]
    };
  },
  mounted: function() {
    //console.log('mounted:',this.employeeDetails);
    this.employeeData.profilePic = this.employeeDetails.imgSrc;
    this.employeeData.name = this.employeeDetails.employeeName;
    this.employeeData.fbpMonth = this.employeeDetails.month;
    this.employeeData.totalEligibility = this.employeeDetails.totalEligibility;
    this.employeeData.totalClaimed = this.employeeDetails.claimedAmount;
    this.employeeData.totalApproved = this.employeeDetails.amount_approved;
    this.employeeData.employeeId = this.employeeDetails.employeeId;
    this.getEmployeeClaimDetails(this.employeeDetails.employeeId);
  },
  computed: {
    
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    // ...mapState({
    //   employeesExitsData: state => state.dashboard.add_exit_employees.exits,
    //   employeesJoiningsData: state => state.payroll.joinings.joinings, //fetch all employees data
    // }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods: {

    ...mapActions({
      getFBPClaims: "dashboard/payroll/utilities/settlefbpclaimsemployeepage/fetchAll",
      updateFBPClaims:
        "dashboard/payroll/utilities/settlefbpclaims/updateFBPClaims"
    }),

    async getEmployeeClaimDetails(employeeId){

      try {
        let res =  await this.getFBPClaims(employeeId);
        if (res.status == 200){
            this.particularsList = res.data.payload.data;
          }
          //console.log('particularList:',this.particularsList);
      } catch (error) {
        //console.log(error);
      }
    },

    showInputField(event, columnItem, columnName) {
      if (columnName == "approved") {
        columnItem.isApproved = event;
      } else if (columnName == "reject") {
        columnItem.isRejected = event;
      } else if (columnName == "onHold") {
        columnItem.isOnHold = event;
      }

      //console.log(columnItem);
    },

    async updateFBPClaimsOfEmployee() {
      try {
         let res =  await this.updateFBPClaims({
           id: this.employeeData.employeeId,
           ...this.particularsList
           });

          //console.log('updateFBPClaimsOfEmployee:',res);
          
          if (res.status == 200){
              this.$emit('cancel', false);
          }
      } catch (error) {
        //console.log(error);
      }
    },

    save() {
      //console.log("afterEdit", this.particularsList);
      this.updateFBPClaimsOfEmployee();
    }
  }
};
</script>
<style lang="scss" scoped>
.empl-fbp-card {
  border: 1px solid #dedede;
  border-radius: 2px;
  padding: 10px;
}
.table-input {
  width: 60%;
}
.empl-fbp-table {
  .particular-table {
    background-color: #e6e6e6;
    width: 100%;
    border-collapse: collapse;
    th,
    td {
      padding: 18px;
    }
    thead {
      th {
        border-bottom: 2px solid #34c0be;
      }
    }
    tbody {
      tr {
        background-color: #f9f9f9;
      }
    }
    .tableInput {
      width: 50%;
    }
  }
}
.bottom-line {
  border-bottom: 1px solid #34c0be;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 15px;
}
.border-top {
  border-top: 2px solid #34c0be;
  background-color: #e6e6e6 !important;
}
.profile {
  display: inline-flex;
  width: 100%;
  .emp-image {
    width: auto !important;
    height: 100%;
  }
  .details {
    margin-left: 20px;
    width: 100%;
    p {
      margin-bottom: 5px;
      font-weight: 500;
    }
    .typeface {
      color: #b5b4b4;
      font-size: 12px;
      font-weight: 500;
      .month {
        color: #6d6d6d;
      }
    }
    .total-amount {
      color: #34c0be;
    }
  }
}
.filters {
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(3, minmax(180px, 1fr));
}
</style>
